var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import closeIcon from "../assets/icons/close.svg";
import { getUserProfileDetails, patchUserProfileDetails, } from "../utils/userProfile";
import toast from "react-hot-toast";
import { makeSessionRequest } from "../utils/makeSessionRequest";
export default function ProfileSettingsForm({ show, closeForm, }) {
    const [profileDetails, setProfileDetails] = useState(undefined);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    useEffect(() => {
        (() => __awaiter(this, void 0, void 0, function* () {
            var _a;
            setIsLoading(true);
            try {
                const profileInfo = yield getUserProfileDetails();
                setProfileDetails({
                    first_name: (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.first_name) || "",
                    last_name: (profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.last_name) || "",
                    designation: ((_a = profileInfo === null || profileInfo === void 0 ? void 0 : profileInfo.custom_data) === null || _a === void 0 ? void 0 : _a.designation) || "",
                });
                setIsLoading(false);
            }
            catch (error) {
                setIsLoading(false);
                toast.error("Unable to fetch profile details");
            }
        }))();
    }, [show]);
    const handleChange = (e) => {
        if (profileDetails) {
            setProfileDetails(Object.assign(Object.assign({}, profileDetails), { [e.target.name]: e.target.value }));
        }
        else {
            setProfileDetails({ [e.target.name]: e.target.value });
        }
    };
    const onSave = (e) => __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        const patchData = {
            first_name: profileDetails.first_name,
            last_name: profileDetails.last_name,
            custom_data: { designation: profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.designation },
        };
        try {
            setIsSaving(true);
            yield patchUserProfileDetails(patchData);
            toast.success("Profile details updated");
            setIsSaving(false);
        }
        catch (error) {
            setIsSaving(false);
            toast.error("Failed to save profile details");
        }
    });
    return (_jsx("div", { children: _jsx(Modal, Object.assign({ show: show, onClose: () => null, type: "profile" }, { children: _jsxs("form", Object.assign({ className: "p-2 w-96 flex flex-col items-center", style: { maxHeight: "85vh" } }, { children: [_jsxs("div", Object.assign({ className: "flex mb-4 w-full" }, { children: [_jsx("h1", Object.assign({ className: "font-bold text-lg " }, { children: "Profile Settings" })), _jsx("img", { className: "ml-auto cursor-pointer", onClick: () => {
                                    if (!isLoading || !isSaving) {
                                        closeForm();
                                        makeSessionRequest("closed_quotation_modal");
                                    }
                                }, src: closeIcon, alt: "close" })] })), _jsxs("div", Object.assign({ className: "w-full flex flex-col" }, { children: [_jsx("p", Object.assign({ className: "mb-2" }, { children: "First name: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", name: "first_name", type: "text", value: profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.first_name, onChange: handleChange, disabled: isLoading, placeholder: "Enter first name" }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Last name: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", name: "last_name", type: "text", value: profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.last_name, onChange: handleChange, disabled: isLoading, placeholder: "Enter last name" }), _jsx("p", Object.assign({ className: "mb-2" }, { children: "Designation: " })), _jsx("input", { className: "px-4 py-2 w-full focus:outline-none border mb-4", name: "designation", type: "text", value: profileDetails === null || profileDetails === void 0 ? void 0 : profileDetails.designation, onChange: handleChange, disabled: isLoading, placeholder: "Enter designation" }), _jsx("button", Object.assign({ disabled: isLoading, className: `tracking-widest text-xs my-4  py-3 px-8 hover:bg-black bg-customBlack-light text-white rounded-full font-bold transform transition-colors ${isLoading || isSaving ? "opacity-30" : ""}`, onClick: onSave }, { children: isLoading ? "Loading..." : isSaving ? "SAVING...." : "SAVE" }))] }))] })) })) }));
}
